import { Badge } from '@toggle/design-system';
import { highlight } from '@toggle/helpers';
import { MappedEntity } from '@toggle/toggle';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { EllipsisDetector } from '~/components/elipsis-detector/EllipsisDetector';

import * as S from './ChatDropdownItem.styles';

export interface ChatDropdown {
  entity?: MappedEntity;
  leftText: string;
  rightText: string;
  tag: string;
  id: string;
  defaultSnake: string;
  description: string;
}

interface ChatDropdownItemProps {
  highlighted: string;
  item: ChatDropdown;
  isActive: boolean;
  isFocused: boolean;
}

export const ChatDropdownItem: FC<ChatDropdownItemProps> = ({
  highlighted,
  item,
  isActive,
  isFocused,
}) => {
  const { t } = useTranslation('analyze');
  return (
    <S.Wrapper data-testid="autocomplete-part">
      <EllipsisDetector label={item.leftText}>
        <S.LeftText data-testid="leftText">
          {isFocused ? item.leftText : highlight(item.leftText, highlighted)}
        </S.LeftText>
      </EllipsisDetector>
      <EllipsisDetector label={item.rightText}>
        <S.RightText data-testid="rightText">
          {isFocused ? item.rightText : highlight(item.rightText, highlighted)}
        </S.RightText>
      </EllipsisDetector>
      <Badge
        color={isActive || isFocused ? 'primary' : 'neutral'}
        badgeStyle="outline"
        size="medium"
        leftSection={
          <S.StyledFlagIcon rounded countryCode={item?.entity?.country?.long} />
        }
        label={
          item.entity?.sub_class && (
            <S.BadgeLabel>
              {
                /* i18next-extract-disable-next-line */
                t(`analyze:assetSubClass.${item.entity?.sub_class}`)
              }
            </S.BadgeLabel>
          )
        }
      />
    </S.Wrapper>
  );
};
